import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'

import { Translations } from 'modules/questionnaires/lib/types'

type Props = {
  translations: Translations['section']['delete_modal']
  onDelete: () => void
  onClose: () => void
}

const DeleteSectionModal: React.FC<Props> = ({ translations, onDelete, onClose }) => {
  return (
    <Modal
      title={translations.title}
      description={translations.description}
      illustration="alert"
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {translations.cancel}
          </Button>
          <Button type="primary" submit>
            {translations.confirm}
          </Button>
        </>
      }
    />
  )
}
export default DeleteSectionModal
